import powerfullIcon from "@assets/powerfull.png"
import Button from "@components/Button"
import Layout from "@components/Layout"
import { Trans, useTranslation } from "react-i18next"
import { Form } from "react-router-dom"

export default function PowerfulTransitionPage() {
  const { t } = useTranslation()

  return (
    <Layout>
      <div className="flex grow flex-col items-center justify-center gap-5 text-center">
        <img
          src={powerfullIcon}
          alt="Powerful icon"
          className="h-auto w-40 rounded-lg"
        />

        <h1 className="custom-heading">
          {t("pages.onboardingV2.powerfulTransition.heading")}
        </h1>

        <p className="text-xl">
          <Trans
            components={{
              colored: <span className="custom-text-colored font-bold" />,
            }}
            i18nKey="pages.onboardingV2.powerfulTransition.text"
          />
        </p>
      </div>

      <Form className="shrink-0" method="post">
        <input
          name={t("pages.onboardingV2.powerfulTransition.heading", {
            lng: "en",
          })}
          type="hidden"
          value={t("shared.continue", { lng: "en" })}
        />

        <Button title={t("shared.continue")} type="submit" />
      </Form>
    </Layout>
  )
}
